<!-- ---TEMPLATE--- -->
<template> 
  <div class="magazine-parent">
    <el-row>
      <!-- the row, going to repeat -->
      <div class="rowSpan24" id="magazineFontSizeChange" v-loading.fullscreen.lock="fullscreenLoading">
        <el-menu class="el-menu-demo" mode="horizontal">
          <el-menu-item index="1">
            <div class="magazineMenuTitle" v-for="(set,index) in groups" v-bind:key="index">
              <div class="magazineNewsTitle"  v-on:click="set.open = !set.open" v-if="getMagazineRegisterFlag">雑誌({{getMagazineFirstTabCheckboxValue}}/{{getThemeMagazineCount}}件)</div>
              <div class="magazineNewsTitle"  v-on:click="set.open = !set.open" v-else>雑誌(未登録)</div>
            </div>
          </el-menu-item>  
          <el-menu-item index="2">
            <div class="menuLable" v-if="getSortMagazineDateText">
              <div class="selectList year-drop">年月日：{{getSelectedMagazineSortDate}}</div>
              <i class="el-icon-arrow-up year-arrow" v-if="getAscendingMagazineDateIcon"></i>
              <i class="el-icon-arrow-down year-arrow" v-if="getDecendingMagazineDateIcon"></i>
            </div>
            <div class="menuLable" v-if="getSortMagazineTitleText">
              <div class="selectList year-drop">見出し：{{getSelectedMagazineSortTitle}}</div>
              <i class="el-icon-arrow-up year-arrow" v-if="getAscendingMagazineTitleIcon"></i>
              <i class="el-icon-arrow-down year-arrow" v-if="getDecendingMagazineTitleIcon"></i>
            </div>
          </el-menu-item>
          <el-menu-item index="3">
            <div class="strip first-strip" v-if="getSortMagazineDateText == true || getSortMagazineTitleText == true"></div>
          </el-menu-item>
          <el-menu-item index="4" class="select_custom" v-if="all_articles_selectable_flag">
            <div class="menuLable">
              <el-checkbox class="checkList select_custom_box" v-model="getMagazineCheckboxSelect" @change="handleCheckAllChange">
                <div class="selectList select_custom_label">全て選択</div>
              </el-checkbox>
            </div>
          </el-menu-item>  
          <el-menu-item index="5">
           <div class="strip" v-if="all_articles_selectable_flag"></div>
            <div style="width: 6px;" v-else></div>
          </el-menu-item>
          <el-menu-item index="6">
           <div class="sortIcon">
              <el-popover placement="bottom-start" width="200" trigger="click" v-model="visible" class="bigPopUp">                
                <div class="menuLable" slot="reference">
                  <div class="iconSVG ico_sort_up" tabindex="0"></div>
                  <div class="IconSort">ソート</div>   
                </div>  
                <el-form class="selectForm">
                  <el-form-item label="年月日" class="dateSelectLable">
                    <el-select v-model="getMagazineDateValue" class="dateSelect" @change="selectDateValue($event)">
                      <div class="drop1">
                        <el-option
                          class="dateOption"
                          v-for="item in optionValue"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </div>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="見出し" class="headingLable">
                    <el-select v-model="getMagazineTitleValue" class="heading" @change="selectTitleValue($event)">
                      <div class="drop2">
                        <el-option
                          class="headingOption"
                          v-for="items in MagazineOptions"
                          :key="items.value"
                          :label="items.label"
                          :value="items.value"
                        ></el-option>
                      </div>
                    </el-select>
                  </el-form-item>
                  <el-row type="flex" justify="space-between">
                    <el-button round class="roundGray" @click="clear" tabindex="1">リセット</el-button>
                    <el-row>
                      <el-button round class="roundGrayDark" @click="cancelSort" tabindex="1">キャンセル</el-button>
                      <el-button round class="roundBlue" @click="articleSorting" tabindex="1">OK</el-button>
                    </el-row>
                  </el-row>
                </el-form>
              </el-popover>
            </div>
          </el-menu-item>
          <el-menu-item index="7">
           <div class="strip"></div>
          </el-menu-item>
          <el-menu-item index="8">
           <div class="menuLable">
              <div class="iconSVG csvOutput ico_csv-output_up" @click="downloadArticleAsCsvFormat" tabindex="0"></div>
              <div class="csvFile" @click="downloadArticleAsCsvFormat">CSV出力</div>
            </div>
          </el-menu-item>
          <el-menu-item index="9" class="list__size">
            <div class="toolTipDiv ">
              <el-tooltip class="item " effect="light"  placement="bottom-end" id="">
                <div class="display-size " slot="content">
                  <ul>
                    <li v-on:click="magazineDecrease" class="activeFont" v-bind:class="{ active: isActive }"><span>小</span></li>
                    <li v-on:click="magazineReset" class="activeFont" v-bind:class="{ active: isMedActive }"><span>中</span></li>
                    <li v-on:click="magazineIncrease" class="activeFont" v-bind:class="{ active: isBigActive }"><span>大</span></li>
                  </ul>
                </div>
                <span class="display">
                  <label for="" class="DisplaySize">表示サイズ</label>
                </span>
              </el-tooltip>
            </div> 
          </el-menu-item>
        </el-menu>
      </div>
      <el-col :span="24">
        <div class="accord">
          <div v-for="(set,index) in groups" v-bind:key="index">
            <div id="anim">
              <transition name="slide">
                  <el-collapse-transition> 
                <div v-show="set.open">
                  <div v-for="(item,index) in set.items" v-bind:key="index">
                    <el-checkbox-group v-model="getMagazineCsvDetails" @change="handleCheckedArticlesChange">
                      <AllMagazineAriticleDraggable ref="AllMagazineAriticleDraggableRef" v-bind:articleList="getMagazineArticledetails" click="magazineFontSizeChange"/>
                    </el-checkbox-group>
                  </div>
                </div>
                  </el-collapse-transition>
              </transition>
            </div>
          </div>
        </div>
      </el-col>
    </el-row> 
  </div>
</template>
 
<!-- --SCRIPT--- -->
<script>

import { mapGetters } from "vuex";
import AllMagazineAriticleDraggable from "./AllMagazineAriticleDraggable.vue";
import $ from "jquery";
import json from "../../components/config.json";
 
export default {
 
  components: {
    AllMagazineAriticleDraggable
  },
  data() {
    return {
      fullscreenLoading: false,
      visible: false,
      groups: {
        "group 1": {
          name: "Menu 1",
          open: "false",
          items: ["item1"]
        }
      },
      drag: false,
      optionValue: [
        {
          value: "なし",
          label: "なし"
        },
        {
          value: "昇順",
          label: "昇順"
        },
        {
          value: "降順",
          label: "降順"
        }
      ],
      MagazineOptions: [
        {
          value: "なし",
          label: "なし"
        },
        {
          value: "昇順",
          label: "昇順"
        },
        {
          value: "降順",
          label: "降順"
        }
      ],
      select_date_value: '',
      select_title_value: '',
      scroll_sort_date: '',
      scroll_sort_title: '',
      startDateResult: '',
      endDateResult: '',
      userId: '',
      contractId: '',
      theme_browsing: '',
      checklistVal: [],
      checkAll: false,
      isActive: false,
      isMedActive: true,
      isBigActive: false,
      csv_download_flag: false,
      all_articles_selectable_flag: false,
      setCancelValue: true,
    };
  },
  methods: {
    cancelSort(){
      this.$LogButtonEvent("MagazineTab","Cancell");
      this.$LogMethodIN("MagazineTab","cancelSort");
      if(this.setCancelValue)
      {
        this.$store.commit('situation/setMagazineDateValue', 'なし');
        this.$store.commit('situation/setMagazineTitleValue', 'なし');
        this.select_date_value='';
        this.select_title_value='';
        this.$store.commit('situation/setSortMagazineDateText', false);
        this.$store.commit('situation/setSortMagazineTitleText', false);
        this.$store.commit('situation/setAscendingMagazineDateIcon', false);
        this.$store.commit('situation/setDecendingMagazineDateIcon', false);
        this.$store.commit('situation/setAscendingMagazineTitleIcon', false);
        this.$store.commit('situation/setDecendingMagazineTitleIcon', false);
      }
      else
      {
        if(this.getSelectedMagazineSortDate != '')
        {
          this.$store.commit('situation/setMagazineDateValue', this.getSelectedMagazineSortDate);
          this.$store.commit('situation/setMagazineTitleValue', 'なし');

        }
        else if(this.getSelectedMagazineSortTitle != '')
        {
          this.$store.commit('situation/setMagazineDateValue', 'なし');
          this.$store.commit('situation/setMagazineTitleValue', this.getSelectedMagazineSortTitle);
        }
      }
      this.visible = false
      this.$LogMethodOut("MagazineTab","cancelSort");
    },
    //method for sorting the article based on article date and title
    articleSorting(){
      this.$LogButtonEvent("magazine","ArticleSorting");
      this.$LogMethodIN("magazine","articleSorting");

    
      //set the date and title sort values which is selected in All Media Tab
      this.select_date_value = this.getMagazineDateValue;
      this.select_title_value = this.getMagazineTitleValue;

      // 2021/05/25  #11297  START  
      if(this.$store.getters['situation/getSortMagazineDateText'])
      {
        if((this.select_date_value == "昇順" && !this.$store.getters['situation/getAscendingMagazineDateIcon']) ||
        (this.select_date_value == "降順" && !this.$store.getters['situation/getDecendingMagazineDateIcon']) ||
        (this.select_date_value == "なし" || this.select_date_value == ''))
        {
          if(this.getMagazineCsvDetails.length != 0)
          {
            this.$store.commit("situation/setMagazineCsvDetails", []);
            // 2021/06/28  #11594  START
            this.$store.commit('situation/setMagazineFirstTabCheckboxValue', 0);
            // 2021/06/28  #11594  END
          }

          if(this.$store.getters['situation/getMagazineCheckboxSelect'])
          {
            this.$store.commit('situation/setMagazineCheckboxSelect', false);
         }
        }
      }
      else if(this.$store.getters['situation/getSortMagazineTitleText'])
      {
        if((this.select_title_value == "昇順" && !this.$store.getters['situation/getAscendingMagazineTitleIcon']) ||
        (this.select_title_value == "降順" && !this.$store.getters['situation/getDecendingMagazineTitleIcon']) ||
        (this.select_title_value == "なし" || this.select_title_value == ''))
        {
          if(this.getMagazineCsvDetails.length != 0)
          {
            this.$store.commit("situation/setMagazineCsvDetails", []);
            // 2021/06/28  #11594  START
            this.$store.commit('situation/setMagazineFirstTabCheckboxValue', 0);
            // 2021/06/28  #11594  END
          }

          if(this.$store.getters['situation/getMagazineCheckboxSelect'])
          {
            this.$store.commit('situation/setMagazineCheckboxSelect', false);
          }
        }
      }
      else if((this.select_title_value == "昇順" || this.select_title_value == '降順' ||
      this.select_date_value == "昇順" || this.select_date_value == "降順")
      && !this.$store.getters['situation/getSortMagazineDateText']
      && !this.$store.getters['situation/getSortMagazineTitleText'])
      {
        if(this.getMagazineCsvDetails.length != 0)
          {
            this.$store.commit("situation/setMagazineCsvDetails", []);
            // 2021/06/28  #11594  START
            this.$store.commit('situation/setMagazineFirstTabCheckboxValue', 0);
            // 2021/06/28  #11594  END
          }

          if(this.$store.getters['situation/getMagazineCheckboxSelect'])
          {
            this.$store.commit('situation/setMagazineCheckboxSelect', false);
          }
      }
      // 2021/05/25  #11297  END  

      if(this.select_date_value != '' && this.select_date_value != 'なし')
      {
        this.$store.commit('situation/setSelectedMagazineSortDate', this.select_date_value);
        this.$store.commit('situation/setSelectedMagazineSortTitle', '');

        this.$store.commit('situation/setSortMagazineDateText', true);
        this.$store.commit('situation/setSortMagazineTitleText', false);
        if(this.select_date_value == "昇順")
        {
          this.scroll_sort_date = 'asc';
          this.scroll_sort_title = '';
          this.$store.commit('situation/setAscendingMagazineDateIcon', true);
          this.$store.commit('situation/setDecendingMagazineDateIcon', false);
        }
        else if(this.select_date_value == "降順")
        {
          this.scroll_sort_date = 'desc';
          this.scroll_sort_title = '';
          this.$store.commit('situation/setAscendingMagazineDateIcon', false);
          this.$store.commit('situation/setDecendingMagazineDateIcon', true);
        }
      }
      else if(this.select_title_value != '' && this.select_title_value != 'なし')
      {
        this.$store.commit('situation/setSelectedMagazineSortDate', '');
        this.$store.commit('situation/setSelectedMagazineSortTitle', this.select_title_value);

        this.$store.commit('situation/setSortMagazineDateText', false);
        this.$store.commit('situation/setSortMagazineTitleText', true);
        if(this.select_title_value == "昇順")
        {
          this.scroll_sort_title = 'asc';
          this.scroll_sort_date = '';
          // 2021/06/28  #11594  START
          this.$store.commit('situation/setAscendingMagazineTitleIcon', true);
          this.$store.commit('situation/setDecendingMagazineTitleIcon', false);
          // 2021/06/28  #11594  END
        }
        else if(this.select_title_value == "降順")
        {
          this.scroll_sort_title = 'desc';
          this.scroll_sort_date = '';
          this.$store.commit('situation/setAscendingMagazineTitleIcon', false);
          this.$store.commit('situation/setDecendingMagazineTitleIcon', true);
        }
      }
      else if((this.select_date_value == 'なし' || this.select_date_value == '') && (this.select_title_value == 'なし' || this.select_title_value == ''))
      {
        this.scroll_sort_title = '';
        this.scroll_sort_date = '';
        this.$store.commit('situation/setSelectedMagazineSortDate', 'なし');
        this.$store.commit('situation/setSelectedMagazineSortTitle', 'なし');
        this.$store.commit('situation/setSortMagazineDateText', false);
        this.$store.commit('situation/setSortMagazineTitleText', false);
      }

      
      this.setCancelValue = false;
      var themeValue = this.getSelectedTheme[0].value;
      var theme_id = this.getSelectedTheme[0].id;
      var magazineinputParam;
      
      if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)//if article is loaded based on theme values
      {
        if(themeValue == "Theme")//if selected theme value is theme
        {
          magazineinputParam ={
            contract_id: this.contractId,
            data_section: 5,
            process_date_start:this.getDefaultThemeStartDate,
            process_date_end:this.getDefaultThemeEndDate,
            sort_date: this.scroll_sort_date,
            sort_title: this.scroll_sort_title,
            start_num:1,
            load_num:this.getMagazineTotalNewsCount,
            theme_id: theme_id
          }
        }
        else if(themeValue == "Theme Group")//if selected theme value is theme group
        {
          magazineinputParam ={
            contract_id: this.contractId,
            data_section: 5,
            process_date_start:this.getDefaultThemeStartDate,
            process_date_end:this.getDefaultThemeEndDate,
            sort_date: this.scroll_sort_date,
            sort_title: this.scroll_sort_title,
            start_num:1,
            load_num:this.getMagazineTotalNewsCount,
            theme_group_id: theme_id
          }
        }
        else//if selected theme value is topics
        {
          magazineinputParam ={
            contract_id: this.contractId,
            data_section: 5,
            process_date_start:this.getDefaultThemeStartDate,
            process_date_end:this.getDefaultThemeEndDate,
            sort_date: this.scroll_sort_date,
            sort_title: this.scroll_sort_title,
            start_num:1,
            load_num:this.getMagazineTotalNewsCount,
            topics_id: theme_id
          }
        }
        //hide the sorting dialog box
        this.visible = false;
        this.fullscreenLoading = true;
        //Api call for sorting the news article
        this.$store.dispatch('communication/getMagazineArticles', magazineinputParam).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })
      }
      else if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == true)//if article is loaded based on today's article values
      {
        magazineinputParam ={
          contract_id: this.contractId,
          data_section: 5,
          process_date_start:this.getDefaultThemeStartDate,
          process_date_end:this.getDefaultThemeEndDate,
          sort_date: this.scroll_sort_date,
          sort_title: this.scroll_sort_title,
          start_num:1,
          load_num:this.getMagazineTotalNewsCount
        }

        //hide the sorting dialog box
        this.visible = false;
        this.fullscreenLoading = true;
        //Api call for sorting the news article
        this.$store.dispatch('communication/getMagazineArticles', magazineinputParam).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })
        
      }
      else if(this.getSearchConditionKey == 1)
      {
        if(this.getSearchValue != '')//if value is selected from search dropdown
        {
          magazineinputParam ={
            contract_id: this.contractId,
            user_id: this.userId,
            contract_kbn: 5,
            display_id: 'SID0002',
            process_date_from:this.getSearchStartDate,
            process_date_to:this.getSearchEndDate,
            theme_browsing: this.theme_browsing,
            search_title: this.getSearchValue,
            sort_date: this.scroll_sort_date,
            sort_title: this.scroll_sort_title,
            start_num:1,
            load_num:this.getMagazineTotalNewsCount
          }
        }
        else if(this.getKeywordValue != '')//if keyword textbox is not equal to empty
        {
          if(this.getMediaValue != '')//if media texbox is not equal to empty
          {
            magazineinputParam ={
              contract_id: this.contractId,
              user_id: this.userId,
              contract_kbn: 5,
              display_id: 'SID0002',
              process_date_from:this.getSearchStartDate,
              process_date_to:this.getSearchEndDate,
              theme_browsing: this.theme_browsing,
              key_word: this.getKeywordValue,
              media_name: this.getMediaValue,
              sort_date: this.scroll_sort_date,
              sort_title: this.scroll_sort_title,
              start_num:1,
              load_num:this.getMagazineTotalNewsCount
            }
          }
          else//if media texbox is equal to empty
          {
            magazineinputParam ={
              contract_id: this.contractId,
              user_id: this.userId,
              contract_kbn: 5,
              display_id: 'SID0002',
              process_date_from:this.getSearchStartDate,
              process_date_to:this.getSearchEndDate,
              theme_browsing: this.theme_browsing,
              key_word: this.getKeywordValue,
              sort_date: this.scroll_sort_date,
              sort_title: this.scroll_sort_title,
              start_num:1,
              load_num:this.getMagazineTotalNewsCount
            }
          }
        }
        else//if keyword textbox is equal to empty
        {
          if(this.getMediaValue != '')//if media texbox is not equal to empty
          {
            magazineinputParam ={
              contract_id: this.contractId,
              user_id: this.userId,
              contract_kbn: 5,
              display_id: 'SID0002',
              process_date_from:this.getSearchStartDate,
              process_date_to:this.getSearchEndDate,
              theme_browsing: this.theme_browsing,
              media_name: this.getMediaValue,
              sort_date: this.scroll_sort_date,
              sort_title: this.scroll_sort_title,
              start_num:1,
              load_num:this.getMagazineTotalNewsCount
            }
          }
          else//if media texbox is equal to empty
          {
            magazineinputParam ={
              contract_id: this.contractId,
              user_id: this.userId,
              contract_kbn: 5,
              display_id: 'SID0002',
              process_date_from:this.getSearchStartDate,
              process_date_to:this.getSearchEndDate,
              theme_browsing: this.theme_browsing,
              sort_date: this.scroll_sort_date,
              sort_title: this.scroll_sort_title,
              start_num:1,
              load_num:this.getMagazineTotalNewsCount
            }
          }
        }

        //hide the sorting dialog box
        this.visible = false;
        this.fullscreenLoading = true;
        //Api call for sorting the news article(AID0071)
        this.$store.dispatch('communication/getMagazineArticleUsingSorting', magazineinputParam).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })
      }
      else if(this.getSearchConditionKey == 2)
      {
        if(this.getKeywordValue != '')
        {
          magazineinputParam ={
            contract_id: this.contractId,
            user_id: this.userId,
            contract_kbn: 5,
            display_id: 'SID0002',
            process_date_from:this.getSearchStartDate,
            process_date_to:this.getSearchEndDate,
            theme_browsing: this.theme_browsing,
            key_word: this.getKeywordValue,
            sort_date: this.scroll_sort_date,
            sort_title: this.scroll_sort_title,
            start_num:1,
            load_num:this.getMagazineTotalNewsCount
          }
        }
        else
        {
          magazineinputParam ={
            contract_id: this.contractId,
            user_id: this.userId,
            contract_kbn: 5,
            display_id: 'SID0002',
            process_date_from:this.getSearchStartDate,
            process_date_to:this.getSearchEndDate,
            theme_browsing: this.theme_browsing,
            sort_date: this.scroll_sort_date,
            sort_title: this.scroll_sort_title,
            start_num:1,
            load_num:this.getMagazineTotalNewsCount
          }
        }
        

        //hide the sorting dialog box
        this.visible = false;
        this.fullscreenLoading = true;
        //Api call for sorting the news article(AID0071)
        this.$store.dispatch('communication/getMagazineArticleUsingSorting', magazineinputParam).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })
      }
      else
      {
        //no action needed
      }
      this.$LogMethodOut("magazine","articleSorting");
    },
    sort() {
      this.list = this.list.sort((a, b) => a.order - b.order);
    },
    //method for reset the date and title value for sorting the article
    clear (){
      this.$LogButtonEvent("magazine","Reset");
      this.$LogMethodIN("magazine","clear");
      this.$store.commit('situation/setMagazineDateValue', 'なし');
      this.$store.commit('situation/setMagazineTitleValue', 'なし');
      this.select_date_value= '';
      this.select_title_value= '';
      this.scroll_sort_date = '';
      this.scroll_sort_title = '';
      this.$LogMethodOut("magazine","clear");
    },
    //method for get the article no from selected article checkboxex
    handleCheckAllChange(val){
      this.$LogButtonEvent("magazine","SelectAll");
      this.$LogMethodIN("magazine","handleCheckAllChange");      
      if(val)
      {
        if(this.getMagazineArticledetails.length == this.getThemeMagazineCount)
        {
          this.checklistVal = val ? this.getArticlesIds() : [];        
          this.$store.commit('situation/setMagazineCsvDetails', this.checklistVal);
          if(this.checklistVal.length > 0)
          {
            this.$store.commit("situation/setMagazineFirstTabCheckboxValue", this.checklistVal.length);
            this.$store.commit('situation/setMagazineCheckboxSelect', true);
          }
          else
          {
            this.$store.commit("situation/setMagazineFirstTabCheckboxValue", this.checklistVal.length);
            this.$store.commit('situation/setMagazineCheckboxSelect', false);
          }
        }
        else
        {
          var themeValue = this.getSelectedTheme[0].value;
          var theme_id = this.getSelectedTheme[0].id;
          var startNumCount = this.getMagazineArticledetails.length + 1;
          var loadNumCount = this.getThemeMagazineCount - this.getMagazineArticledetails.length;
          var magazineinputParam;
          
          if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)
          {
            if(themeValue == "Theme")
            {
              magazineinputParam = {
                contract_id: this.contractId,
                data_section: 5,
                process_date_start: this.getDefaultThemeStartDate,
                process_date_end: this.getDefaultThemeEndDate,
                sort_date: this.getScrollingMagazineDate,
                sort_title: this.getScrollingMagazineTitle,
                start_num: startNumCount,
                load_num: loadNumCount,
                theme_id: theme_id
              };
            }
            else if(themeValue == "Theme Group")
            {
              magazineinputParam = {
                contract_id: this.contractId,
                data_section: 5,
                process_date_start: this.getDefaultThemeStartDate,
                process_date_end: this.getDefaultThemeEndDate,
                sort_date: this.getScrollingMagazineDate,
                sort_title: this.getScrollingMagazineTitle,
                start_num: startNumCount,
                load_num: loadNumCount,
                theme_group_id: theme_id
              };
            }
            else
            {
              magazineinputParam = {
                contract_id: this.contractId,
                data_section: 5,
                process_date_start: this.getDefaultThemeStartDate,
                process_date_end: this.getDefaultThemeEndDate,
                sort_date: this.getScrollingMagazineDate,
                sort_title: this.getScrollingMagazineTitle,
                start_num: startNumCount,
                load_num: loadNumCount,
                topics_id: theme_id
              };
            }

            var existingArticleDetails = [];

            existingArticleDetails = [...existingArticleDetails, magazineinputParam, this.getMagazineArticledetails]

            this.fullscreenLoading = true;
            this.$store.dispatch("communication/getMagazineArticles", existingArticleDetails).then(() => {
              this.fullscreenLoading = false;
              this.checklistVal = val ? this.getArticlesIds() : [];
              this.$store.commit('situation/setMagazineCsvDetails', this.checklistVal);
              if(this.checklistVal.length > 0)
              {
                this.$store.commit("situation/setMagazineFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setMagazineCheckboxSelect', true);
              }
              else
              {
                this.$store.commit("situation/setMagazineFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setMagazineCheckboxSelect', false);
              }
            }).catch(()=>{
              this.fullscreenLoading = false;
              this.checklistVal = val ? this.getArticlesIds() : [];
              this.$store.commit('situation/setMagazineCsvDetails', this.checklistVal);
              if(this.checklistVal.length > 0)
              {
                this.$store.commit("situation/setMagazineFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setMagazineCheckboxSelect', true);
              }
              else
              {
                this.$store.commit("situation/setMagazineFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setMagazineCheckboxSelect', false);
              }
            });
          }
          else if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == true)
          {
            
            magazineinputParam = {
              contract_id: this.contractId,
              data_section: 5,
              process_date_start: this.getDefaultThemeStartDate,
              process_date_end: this.getDefaultThemeEndDate,
              sort_date: this.getScrollingMagazineDate,
              sort_title: this.getScrollingMagazineTitle,
              start_num: startNumCount,
              load_num: loadNumCount
            };

            var existingTodayArticleDetails = [];

            existingTodayArticleDetails = [...existingTodayArticleDetails, magazineinputParam, this.getMagazineArticledetails]

            this.fullscreenLoading = true;
            this.$store.dispatch("communication/getMagazineArticles", existingTodayArticleDetails).then(() => {
              this.fullscreenLoading = false;
              this.checklistVal = val ? this.getArticlesIds() : [];
              this.$store.commit('situation/setMagazineCsvDetails', this.checklistVal);
              if(this.checklistVal.length > 0)
              {
                this.$store.commit("situation/setMagazineFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setMagazineCheckboxSelect', true);
              }
              else
              {
                this.$store.commit("situation/setMagazineFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setMagazineCheckboxSelect', false);
              }
            }).catch(()=>{
              this.fullscreenLoading = false;
              this.checklistVal = val ? this.getArticlesIds() : [];
              this.$store.commit('situation/setMagazineCsvDetails', this.checklistVal);
              if(this.checklistVal.length > 0)
              {
                this.$store.commit("situation/setMagazineFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setMagazineCheckboxSelect', true);
              }
              else
              {
                this.$store.commit("situation/setMagazineFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setMagazineCheckboxSelect', false);
              }
            });
          }
          else if(this.getSearchConditionKey == 1)
          {
            if(this.getSearchValue != '')
            {
              magazineinputParam ={
                contract_id: this.contractId,
                user_id: this.userId,
                contract_kbn: 5,
                display_id: 'SID0002',
                process_date_from:this.getDefaultThemeStartDate,
                process_date_to:this.getDefaultThemeEndDate,
                theme_browsing: this.theme_browsing,
                search_title: this.getSearchValue,
                sort_date: this.getScrollingMagazineDate,
                sort_title: this.getScrollingMagazineTitle,
                start_num:startNumCount,
                load_num:loadNumCount
              }
            }
            else if(this.getKeywordValue != '')
            {
              if(this.getMediaValue != '')//if media texbox is not equal to empty
              {
                magazineinputParam ={
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 5,
                  display_id: 'SID0002',
                  process_date_from:this.getDefaultThemeStartDate,
                  process_date_to:this.getDefaultThemeEndDate,
                  theme_browsing: this.theme_browsing,
                  key_word: this.getKeywordValue,
                  media_name: this.getMediaValue,
                  sort_date: this.getScrollingMagazineDate,
                  sort_title: this.getScrollingMagazineTitle,
                  start_num:startNumCount,
                  load_num:loadNumCount
                }
              }
              else
              {
                magazineinputParam ={
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 5,
                  display_id: 'SID0002',
                  process_date_from:this.getDefaultThemeStartDate,
                  process_date_to:this.getDefaultThemeEndDate,
                  theme_browsing: this.theme_browsing,
                  key_word: this.getKeywordValue,
                  sort_date: this.getScrollingMagazineDate,
                  sort_title: this.getScrollingMagazineTitle,
                  start_num:startNumCount,
                  load_num:loadNumCount
                }
              }
            }
            else
            {
              if(this.getMediaValue != '')//if media texbox is not equal to empty
              {
                magazineinputParam ={
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 5,
                  display_id: 'SID0002',
                  process_date_from:this.getDefaultThemeStartDate,
                  process_date_to:this.getDefaultThemeEndDate,
                  theme_browsing: this.theme_browsing,
                  media_name: this.getMediaValue,
                  sort_date: this.getScrollingMagazineDate,
                  sort_title: this.getScrollingMagazineTitle,
                  start_num:startNumCount,
                  load_num:loadNumCount
                }
              }
              else
              {
                magazineinputParam ={
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 5,
                  display_id: 'SID0002',
                  process_date_from:this.getDefaultThemeStartDate,
                  process_date_to:this.getDefaultThemeEndDate,
                  theme_browsing: this.theme_browsing,
                  sort_date: this.getScrollingMagazineDate,
                  sort_title: this.getScrollingMagazineTitle,
                  start_num:startNumCount,
                  load_num:loadNumCount
                }
              }
            }

            var existingSearchArticle = [];

            existingSearchArticle = [...existingSearchArticle, magazineinputParam, this.getMagazineArticledetails];

            this.fullscreenLoading = true;
            //Api call for sorting the news article(AID0071)
            this.$store.dispatch('communication/getMagazineArticleUsingSorting', existingSearchArticle)
            .then(() => {
                this.fullscreenLoading = false;
                this.checklistVal = val ? this.getArticlesIds() : [];
                this.$store.commit('situation/setMagazineCsvDetails', this.checklistVal);
                if(this.checklistVal.length > 0)
                {
                  this.$store.commit("situation/setMagazineFirstTabCheckboxValue", this.checklistVal.length);
                  this.$store.commit('situation/setMagazineCheckboxSelect', true);
                }
                else
                {
                  this.$store.commit("situation/setMagazineFirstTabCheckboxValue", this.checklistVal.length);
                  this.$store.commit('situation/setMagazineCheckboxSelect', false);
                }
              }).catch(()=>{
                this.fullscreenLoading = false;
                this.checklistVal = val ? this.getArticlesIds() : [];
                this.$store.commit('situation/setMagazineCsvDetails', this.checklistVal);
                if(this.checklistVal.length > 0)
                {
                  this.$store.commit("situation/setMagazineFirstTabCheckboxValue", this.checklistVal.length);
                  this.$store.commit('situation/setMagazineCheckboxSelect', true);
                }
                else
                {
                  this.$store.commit("situation/setMagazineFirstTabCheckboxValue", this.checklistVal.length);
                  this.$store.commit('situation/setMagazineCheckboxSelect', false);
                }
              });
          }
          else if(this.getSearchConditionKey == 2)
          {
            if(this.getKeywordValue != '')
            {
              magazineinputParam ={
                contract_id: this.contractId,
                user_id: this.userId,
                contract_kbn: 5,
                display_id: 'SID0002',
                process_date_from:this.getDefaultThemeStartDate,
                process_date_to:this.getDefaultThemeEndDate,
                theme_browsing: this.theme_browsing,
                key_word: this.getKeywordValue,
                sort_date: this.getScrollingMagazineDate,
                sort_title: this.getScrollingMagazineTitle,
                start_num:startNumCount,
                load_num:loadNumCount
              }
            }
            else
            {
              magazineinputParam ={
                contract_id: this.contractId,
                user_id: this.userId,
                contract_kbn: 5,
                display_id: 'SID0002',
                process_date_from:this.getDefaultThemeStartDate,
                process_date_to:this.getDefaultThemeEndDate,
                theme_browsing: this.theme_browsing,
                sort_date: this.getScrollingMagazineDate,
                sort_title: this.getScrollingMagazineTitle,
                start_num:startNumCount,
                load_num:loadNumCount
              }
            }

            var existingSearchKeywordArticle = [];

            existingSearchKeywordArticle = [...existingSearchKeywordArticle, magazineinputParam, this.getMagazineArticledetails];
            this.fullscreenLoading = true;
            //Api call for sorting the news article(AID0071)
            this.$store.dispatch('communication/getMagazineArticleUsingSorting', existingSearchKeywordArticle)
            .then(() => {
                this.fullscreenLoading = false;
                this.checklistVal = val ? this.getArticlesIds() : []
                this.$store.commit('situation/setMagazineCsvDetails', this.checklistVal);
                if(this.checklistVal.length > 0)
                {
                  this.$store.commit("situation/setMagazineFirstTabCheckboxValue", this.checklistVal.length);
                  this.$store.commit('situation/setMagazineCheckboxSelect', true);
                }
                else
                {
                  this.$store.commit("situation/setMagazineFirstTabCheckboxValue", this.checklistVal.length);
                  this.$store.commit('situation/setMagazineCheckboxSelect', false);
                }
              }).catch(()=>{
                this.fullscreenLoading = false;
                this.checklistVal = val ? this.getArticlesIds() : [];
                this.$store.commit('situation/setMagazineCsvDetails', this.checklistVal);
                if(this.checklistVal.length > 0)
                {
                  this.$store.commit("situation/setMagazineFirstTabCheckboxValue", this.checklistVal.length);
                  this.$store.commit('situation/setMagazineCheckboxSelect', true);
                }
                else
                {
                  this.$store.commit("situation/setMagazineFirstTabCheckboxValue", this.checklistVal.length);
                  this.$store.commit('situation/setMagazineCheckboxSelect', false);
                }
              });
          }
          else
          {
            //no action needed
          }
        }
      }
      else
      {
        this.checklistVal = val ? this.getArticlesIds() : [];
      
        this.$store.commit('situation/setMagazineCsvDetails', this.checklistVal);
        if(this.checklistVal.length > 0)
        {
          this.$store.commit("situation/setMagazineFirstTabCheckboxValue", this.checklistVal.length);
          this.$store.commit('situation/setMagazineCheckboxSelect', true);
        }
        else
        {
          this.$store.commit("situation/setMagazineFirstTabCheckboxValue", this.checklistVal.length);
          this.$store.commit('situation/setMagazineCheckboxSelect', false);
        }
        this.$LogMethodOut("magazine","handleCheckAllChange");
      }
    },
    handleCheckedArticlesChange(value){
      this.$LogButtonEvent("magazine","CheckArticle");
      this.$LogMethodIN("magazine","handleCheckedArticlesChange");
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.getMagazineArticledetails.length;
      this.$store.commit('situation/setMagazineCheckboxSelect', this.checkAll);
      this.$LogMethodOut("magazine","handleCheckedArticlesChange");
    },
    //method for get the value from date dropdown
    selectDateValue($event){
      this.$LogButtonEvent("magazine","selectDate");
      this.$LogMethodIN("magazine","selectDateValue");      
      for(var j=0; j<this.optionValue.length;j++)
      {
          if($event == this.optionValue[j].value)
          {
            this.select_date_value = this.optionValue[j]["value"];
					}
      }
      if(this.select_date_value == "昇順")
      {
        this.scroll_sort_date = 'asc';
        this.scroll_sort_title = '';
        this.select_title_value = '';
        this.$store.commit('situation/setMagazineDateValue', '昇順');
        this.$store.commit('situation/setMagazineTitleValue', 'なし');
      }
      else if(this.select_date_value == "降順")
      {
        this.scroll_sort_date = 'desc';
        this.scroll_sort_title = '';
        this.select_title_value = '';
        this.$store.commit('situation/setMagazineDateValue', '降順');
        this.$store.commit('situation/setMagazineTitleValue', 'なし');
      }
      else
      {
        this.scroll_sort_date = '';
        this.$store.commit('situation/setMagazineDateValue', 'なし');
      }
      this.$store.commit("situation/setScrollingMagazineDate", this.scroll_sort_date);
      this.$LogMethodOut("magazine","selectDateValue");
    },
    //method for get the value from title dropdown
    selectTitleValue($event){
      this.$LogButtonEvent("magazine","selectTitle");
      this.$LogMethodIN("magazine","selectTitleValue");
      for(var j=0; j<this.MagazineOptions.length;j++)
      {
        if($event == this.MagazineOptions[j].value)
        {
          this.select_title_value = this.MagazineOptions[j]["value"];
        }
      }
      if(this.select_title_value == "昇順")
      {
        this.scroll_sort_title = 'asc';
        this.scroll_sort_date = '';
        this.select_date_value = '';
        this.$store.commit('situation/setMagazineDateValue', 'なし');
        this.$store.commit('situation/setMagazineTitleValue', '昇順');
      }
      else if(this.select_title_value == "降順")
      {
        this.scroll_sort_title = 'desc';
        this.scroll_sort_date = '';
        this.select_date_value = '';
        this.$store.commit('situation/setMagazineDateValue', 'なし');
        this.$store.commit('situation/setMagazineTitleValue', '降順');
      }
      else
      {
        this.scroll_sort_title = '';
        this.$store.commit('situation/setMagazineTitleValue', 'なし');
      }
      this.$store.commit('situation/setScrollingMagazineTitle', this.scroll_sort_title);
      this.$LogMethodOut("magazine","selectTitleValue");
    },
    //methods for setting the all article content size as small
    magazineDecrease() {
      this.$LogButtonEvent("magazine","SmallNews");
      this.$LogMethodIN("magazine","magazineDecrease");
      $('.AllMagazineInfiniteWrapper').css({
        'max-height' : '200px',
        'height': '200px'
      });
      this.isActive = true;
      this.isMedActive = false;
      this.isBigActive = false;
      this.$LogMethodOut("magazine","magazineDecrease");
    },
    //methods for setting the all article content size as medium
    magazineReset() {
      this.$LogButtonEvent("magazine","CurrentNews");
      this.$LogMethodIN("magazine","magazineReset");
      $('.AllMagazineInfiniteWrapper').css({
        'max-height':'400px',
        'height': '400px'
      });
      this.isActive = false;
      this.isMedActive = true;
      this.isBigActive = false;
      this.$LogMethodOut("magazine","magazineReset");
    },
    //methods for setting the all article content size as large
    magazineIncrease() {
      this.$LogButtonEvent("magazine","BigNews");
      this.$LogMethodIN("magazine","magazineIncrease");
      $('.AllMagazineInfiniteWrapper').css({
        'max-height':'700px',
        'height':'700px'
      });
      this.isActive = false;
      this.isMedActive = false;
      this.isBigActive = true;
      this.$LogMethodOut("magazine","magazineIncrease");
    },
    
    downloadArticleAsCsvFormat(){
      this.$LogButtonEvent("magazine","DownloadCsvFormat");
      this.$LogMethodIN("magazine","downloadArticleAsCsvFormat");
      var article_details = [];
      var magazineArticle = this.getMagazineArticledetails;
      var csvDownloadValues;
      if(this.getMagazineCsvDetails.length != 0)
      {
        // for(var i=0;i<this.getMagazineCsvDetails.length;i++)
        // {
        //   for(var j=0;j<magazineArticle.length;j++)
        //   {
        //      if(magazineArticle[j].article_no == this.getMagazineCsvDetails[i])
        //      {
        //        article_details = [...article_details, {article_id: magazineArticle[j].article_id, data_section: magazineArticle[j].data_section}];
        //      }
        //   }
        // }
        //Modified for BT08460_EXTERNAL-1784
        for(var i=0;i<magazineArticle.length;i++)
        {
          for(var j=0;j<this.getMagazineCsvDetails.length;j++)
          {
             if(magazineArticle[i].article_no == this.getMagazineCsvDetails[j])
             {
               article_details.push({
                 article_id: magazineArticle[i].article_id,
                 data_section: magazineArticle[i].data_section
                });
             }
          }
        }

        var themeValue = this.getSelectedTheme[0].value;
        var theme_id = this.getSelectedTheme[0].id;

        if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)
        {
          if(themeValue == "Theme")
          {
            csvDownloadValues = {
              theme_data_section:5,
              theme_name:theme_id,
              theme_group_name:null,
              topics_name:null,
              articles:article_details
            }
          }
          else if(themeValue == "Theme Group")
          {
            csvDownloadValues = {
              theme_data_section:5,
              theme_name:null,
              theme_group_name:theme_id,
              topics_name:null,
              articles:article_details
            }
          }
          else if(themeValue == "Topics")
          {
            csvDownloadValues = {
              theme_data_section:5,
              theme_name:null,
              theme_group_name:null,
              topics_name:theme_id,
              articles:article_details
            }
          }
          else
          {
            //no action needed
          }
        }
        else
        {
          csvDownloadValues = {
            theme_data_section:5,
            theme_name:null,
            theme_group_name:null,
            topics_name:null,
            articles:article_details
          }
        }

        this.$store.dispatch('communication/downloadArticleDeliveryList', csvDownloadValues).then(() => {
          //After the Ajax call finished check if status is error for showing alert
          var status = this.getCsvDownloadErrStatus;
          var msgdetail = this.getCsvDownloadErrmsgDetail;
          if(status == "1")
          {
            this.$alert(msgdetail,"更新", {  confirmButtonText: 'OK',  })
          }
          else
          {
            //console.log("else");
          }
        });
        
      }
      else
      {
        this.$confirm(
          json["1023_delete_confirm_message"],
          json["1023_delete_confirm_message_title"],
          {
            showCancelButton: false,
            confirmButtonText: "OK"
          }
        );
      }
      this.$LogMethodOut("magazine","downloadArticleAsCsvFormat");
    },
    TapClickedInParent(){
      this.$refs.AllMagazineAriticleDraggableRef[0].noMore();
    },
    getArticlesIds() {
      var articlesIds = [];
      this.getMagazineArticledetails.forEach(function(article){
        articlesIds.push(article.article_no);
      })
      return articlesIds;
    }
  },
  computed: {
    ...mapGetters("situation",["getMagazineArticles", 
                              "getMagazineArticledetails", 
                              "getSelectedTheme", 
                              "getMagazineTotalNewsCount",
                              "getDefaultDate",
                              "getSearchConditionKey",
                              "getSearchValue",
                              "getKeywordValue",
                              "getMediaValue",
                              "getSearchStartDate",
                              "getSearchEndDate",
                              "getMagazineFirstTabCheckboxValue",
                              "getMagazineCsvDetails",
                              "getCsvSearchDownload",
                              "getMagazineCheckboxSelect",
                              "getCsvDownloadErrStatus",
                              "getCsvDownloadErrmsgDetail",
                              "getThemeMagazineCount",
                              "getMagazineRegisterFlag",
                              "getDefaultThemeStartDate",
                              "getDefaultThemeEndDate",
                              "getScrollingMagazineDate",
                              "getScrollingMagazineTitle",
                              "getTodayArticleFlag",
                              "getSelectedMagazineSortDate",
                              "getSelectedMagazineSortTitle",
                              "getAscendingMagazineDateIcon",
                              "getDecendingMagazineDateIcon",
                              "getAscendingMagazineTitleIcon",
                              "getDecendingMagazineTitleIcon",
                              "getSortMagazineDateText",
                              "getSortMagazineTitleText",
                              "getMagazineDateValue",
                              "getMagazineTitleValue"]),
    ...mapGetters("situation0001", ["getUserId",
                                  "getContractId",
                                  "getContractCode",
                                  "getThemeBrowsing",
                                  "getServiceLinkageInfo",
                                  "getUserGroupLinkageInfo",
                                  "getCompanyConfigurationInfo",
                                  "getDefault_Font_Size"]),
  },
  mounted(){

    //get the user id value from session
    this.userId = this.getUserId;

    //get the contract_id value from session
    this.contractId = this.getContractId;

    //get the theme_browsing value from session
    this.theme_browsing = this.getThemeBrowsing;

    //get the user group linkage info value from the session
    var user_group_linkage = this.getUserGroupLinkageInfo;

    for(var k=0;k<user_group_linkage.length;k++)
    {
      if(user_group_linkage[k].data_section == 5)
      {
        if(user_group_linkage[k].media_window_size == 3)
        {
          $('.AllMagazineInfiniteWrapper').css({
            'max-height': '200px',
            'height': '200px' 
            });
          this.isActive = true;
          this.isMedActive = false;
          this.isBigActive = false;
        }
        else if(user_group_linkage[k].media_window_size == 2)
        {
          $('.AllMagazineInfiniteWrapper').css({
            'max-height': '400px',
            'height': '400px'
            });
          this.isActive = false;
          this.isMedActive = true;
          this.isBigActive = false;
        }
        else
        {
          $('.AllMagazineInfiniteWrapper').css({
            'max-height': '700px',
            'height': '700px'
            });
          this.isActive = false;
          this.isMedActive = false;
          this.isBigActive = true;
        }

        this.all_articles_selectable_flag = user_group_linkage[k].all_articles_selectable_flag;
      }
      else
      {
        //no action needed
      }
    }
   
  },
  updated(){
    this.TapClickedInParent();
    var font_size_flag = this.getDefault_Font_Size;
    if(font_size_flag == 0)
    {
      $('.select_custom').css({"width": "64px"});
    }
    else if(font_size_flag == 1)
    {
      $('.select_custom').css({"width": "76px"});
    }
    else
    {
      $('.select_custom').css({"width": "108px"});
    }
  }
};
</script>
 
<!-- --STYLE--- -->
<style>
@import "../../assets/css/style.css";

.checkList .el-checkbox__inner {
  width: var(--checkBoxWidth);
  height: var(--checkBoxHeight);
  border: 2px solid #0097e0 !important;
  border-radius: 4px;
}
.checkList.is-checked .el-checkbox__inner::after {
  height: 10px;
  left: 5.9px;
  top: 1px;
  border-right-width: 2px;
  border-bottom-width: 2px;
  width: 5px;
}
.el-popover.el-popper .el-form .el-form-item .el-form-item__label {
  font-size: 9.6pt;
  padding-right: 8px !important;
      width: 48px;
}
.el-popover.el-popper .el-form .el-row {
  display: -webkit-box;
}
.el-input__suffix {
  right: 2px !important;
}
.el-input__inner {
  padding: 6px !important;
}
.el-icon-arrow-up:before {
  content: "\e6e1";
  font-size: 18px;
  text-shadow: 0px 0px 0.7px var(--grayDark);
}
.el-scrollbar
  > .el-select-dropdown__wrap.el-scrollbar__wrap
  > .el-select-dropdown__list {
  padding: 0px !important;
  background: var(--white) !important;
}
 
.el-scrollbar {
  overflow: hidden;
  position: relative;
  margin-top: -12px;
  width: 100% !important;
  box-shadow: 4px 3px 7px 0 rgba(0, 0, 0, 0.2) !important;
  border: 1px solid var(--grayLight);
  border-radius: 4px;
  background: var(--white);
}
.el-select-dropdown {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

.el-popover.el-popper[x-placement^="bottom"] {
    margin-top: 0px !important;
    margin-left: -11px !important;
    width: 271px !important;
}
.el-popover {
  padding: 0px 8px 8px 8px !important;
}

.el-button.el-button--default.el-popover__reference span {
  display: block;
   background: transparent;
}
 
#magazineFontSizeChange >>> .el-button {
  padding: 0px !important;
  margin: 0px !important;
}

/* element ui default classes end*/
/* -------------------------------------------------------------------------- */
/* custom css */
.dateSelect>.el-input.el-input--suffix.is-focus>.el-input__suffix>.el-input__suffix-inner {
  margin-right: 2px;
}
.dateSelect>.el-input.el-input--suffix>.el-input__suffix>.el-input__suffix-inner {
  margin-right: 2px;
}
.heading>.el-input.el-input--suffix.is-focus>.el-input__suffix>.el-input__suffix-inner {
  margin-right: 2px;
}
.heading>.el-input.el-input--suffix>.el-input__suffix>.el-input__suffix-inner {
  margin-right: 2px;
}
.selectForm > .el-form-item > .el-form-item__content > .el-select.dateSelect .el-input {
  width: 164px;
}
.selectForm > .el-form-item > .el-form-item__content > .el-select.dateSelect {
  width: 164px;
  margin-top: 16px;
}
.drop1 .el-select-dropdown__item.dateOption span {
  position: relative;
    display: block;
    top: 50%;
    transform: translateY(-50%);
}
.drop1 .el-select-dropdown__item.dateOption:first-child {
  margin-top: 3px;
}
.drop1 .el-select-dropdown__item.dateOption {
  height: 23px;
  margin-bottom: 3px;
}
.drop2 .el-select-dropdown__item.headingOption span {
  position: relative;
    display: block;
    top: 50%;
    transform: translateY(-50%);
}
.drop2 .el-select-dropdown__item.headingOption:first-child {
  margin-top: 3px;
}
.drop2 .el-select-dropdown__item.headingOption {
  height: 23px;
  margin-bottom: 3px;
}
.drop1 .el-select-dropdown__item.dateOption:hover{
    background-color: var(--selectHover) !important;
}
.drop2 .el-select-dropdown__item.headingOption:hover{
    background-color: var(--selectHover) !important;
}
.magazine-parent{
    margin-top: 0px;
}
.toolTipTop {
  width: 17px;
    position: absolute;
    left: 18px;
}
 .sortIconImage {
   margin-left: 1px
 }
.selectForm > .el-form-item.dateSelectLable > .el-form-item__label {
  margin-top: 15px;
  margin-left: 30px;
}
.selectForm > .el-form-item.headingLable > .el-form-item__label {
  margin-top: 7px;
  margin-left: 30px;
}

.selectForm
  > .el-form-item
  > .el-form-item__content
  > .el-select.dateSelect
  > .el-input.el-input--suffix
  > .el-input__inner {
  height: 35px !important;
  border: 1px solid var(--grayLight);
}
.selectForm > .el-form-item > .el-form-item__content > .el-select.heading {
  margin-top: 7px;
  width: 164px;
}
.selectForm > .el-form-item > .el-form-item__content > .el-select.heading .el-input {
  width: 164px;
}
.selectForm
  > .el-form-item
  > .el-form-item__content
  > .el-select.heading
  > .el-input.el-input--suffix
  > .el-input__inner {
  height: 35px !important;
  border: 1px solid var(--grayLight);
}
 
/* cancel button  */
.el-row.is-justify-space-between.el-row--flex .roundGrayDark {
  background: var(--white);
  color: var(--grayDark);
  border: 1px solid var(--grayDark2);
}
.el-row.is-justify-space-between.el-row--flex .roundGrayDark:hover {
  background: var(--grayDark2);
  color: var(--white);
  border: 1px solid var(--grayDark2);
}
.el-row.is-justify-space-between.el-row--flex .roundGrayDark:focus {
  background: var(--grayDark);
  color: var(--white);
  border: 1px solid var(--grayDark);
}
.el-row.is-justify-space-between.el-row--flex .el-row .roundGrayDark span {
  display: block;
  margin: 8px 11px 8px 11px;
}
 
/* reset button  */
.el-row.is-justify-space-between.el-row--flex .roundGray {
  background: var(--grayDark2);
  color: var(--white);
  border: 1px solid var(--grayDark2);
  margin-top: 12px !important;
}
.el-row.is-justify-space-between.el-row--flex .roundGray:hover {
  background: var(--white);
  border: 1px solid var(--grayDark2);
  color: var(--grayDark2);
}
.el-row.is-justify-space-between.el-row--flex .roundGray:focus {
  background: var(--grayDark);
  border: 1px solid var(--grayDark);
  color: var(--white);
}
.el-row.is-justify-space-between.el-row--flex .roundGray span {
  display: block;
  margin: 2px 11px 2px 11px;
}
/* Okay button  */
.el-row.is-justify-space-between.el-row--flex .roundBlue {
  background: var(--selectOption);
  color: var(--secondary);
  border: 1px solid var(--secondary);
  margin-left: 8px !important;
}
.el-row.is-justify-space-between.el-row--flex .roundBlue:hover {
  background: var(--secondary);
  border: 1px solid var(--secondary);
  color: var(--white);
}
.el-row.is-justify-space-between.el-row--flex .roundBlue:focus {
  background: var(--okayFocused);
  border: 1px solid var(--okayFocused);
  color: var(--white);
}
.el-row.is-justify-space-between.el-row--flex .roundBlue span {
  display: block;
  margin: 8px 24px 8px 24px;
}
 
 
.menu_grps {
  background-color: #bfaeab;
  font-size: 18px;
  display: inline;
}
#anim {
  overflow-y: hidden;
  width: 100%;
}

.accord {
  display: flex;
  flex-direction: column;
  padding-top: 5px;
}
.webRotate {
  -moz-transition: all 0.2s;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}
.webRotate.down {
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  transform: rotate(90deg) translate(-195%, 46%) !important;;
  position: absolute;
  margin: 8px -2px 4px 0px;
}
.selectList {
  height: 13pt;
}
.webArrowRotate {
  color: var(--secondary);
  font-size: 18px;
  float: right;
  top: 50%;
  position: relative;
      transform: rotate(90deg) translate(-195%, 73%) !important;
  margin: 8px -6px 4px 0px;
  font-weight: bold !important;
      position: absolute;
    right: 0;
    top: 38px;
}
.displaySizeLarge {
  display: inline-block;
  height: 100%;
  width: 100%;
}
.displaySizeLarge div span {
  display: block;
    position: relative;
    top: 50%;
        transform: translateY(-6px) translateX(18px);
}
.displaySizeLarge div {
  font-size: 8pt;
  float: left;
  height: 100%;
  position: relative;
  top: 50%;
  height: 15pt;
  transform: translate(19%, -50%);
  cursor: pointer;
}
.menuLable .selectList, .menuLable .printfile, .menuLable .fileDetail, .menuLable .csvFile, .menuLable .IconSort, .menuLable .selectAll {
  position: relative;
      top: 50%;
        transform: translateY(-50%);
    line-height: 20px;
    color: #000;
}
.menuLable div {
  font-size: 8pt
}
.selectAll {
  margin-left: 4px;
  margin-top: 1px;
  height: 10pt !important;
}
.IconSort {
  margin-left: 4px !important;
  color: #000;
  margin-right: 0px !important;
}
.printfile,
.fileDetail,
.IconSort {
  margin-left: 30px;
  margin-right: 16px;
  height: 10pt !important;
}
.csvFile {
      margin-left: 26px;
  height: 10pt !important;
  margin-top: -1px;
}

.magazine-parent .rowSpan24 {
  border: 1px solid var(--primary);
  border-radius: 4px 4px!important;
  display: flex;
}

.magazine-parent:nth-child(2) {
  margin-top: 1px;
}
.webMenuParent2 {
  display: block;
  height: 100%;
}
.checkList {
  width: var(--checkBoxWidth);
  height: var(--checkBoxHeight);
  margin: auto 4px auto 8px !important;
}
.magazineNewsTitle  {
  margin: 0px 10px;
  text-align: center;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.menuLable {
  display: flex;
}
.menuLable label {
  padding-left: 0px !important
}
.magazineMenuTitle {
  font-size: 9.6pt;
  font-weight: bold;
  color: var(--white);
  background-color: var(--primary);
  min-width: 188px;
}
.sortIcon .el-button:hover {
  background: transparent;
}
.sortIcon .el-button {
  border: none !important;
  padding: 0px !important;
  margin-top: 0px;
}
.sortIcon .el-button span{
  border: none !important;
  background: transparent;
}

.webMenuParent {
  list-style: none;
  display: -webkit-inline-box;
  width: 100%;
      vertical-align: bottom;
          height: 34px;
}
.el-dropdown-link {
  cursor: pointer;
  margin-left: 5px;
}
.button {
  margin-top: 35px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
  list-style: none;
}

.list-group-item {
  cursor: move;
  font-size: 21px;
  background: #f4f4f4;
  margin: 10px 0px;
  padding: 10px;
  border: 1px solid #e4e4e4;
}

.list-group-item i {
  cursor: pointer;
}

/* Tooltip */
.display-size ul{
  list-style: none;
  padding: 0px;
  margin: 0px;
  cursor: pointer;
}

.menuLable .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
background-color: #0097e0 !important;
border-color: #0097e0 !important;
}
 .el-tooltip__popper[x-placement^=bottom] {
    -webkit-box-shadow: 4px 2px 7px rgba(162,164,170,0.6);
    box-shadow: 4px 2px 7px rgba(162,164,170,0.6);
}

/* Alert model popup arrow style */
.el-popper[x-placement^=bottom] .popper__arrow:first-of-type {
  display: none !important;
}
.el-popper[x-placement^=bottom] .popper__arrow{
  top: -18px !important;  
  margin-right: 3px !important;
  border-top-width: 0px !important;
  border-bottom-color: var(--grayLight) !important;
  display: block !important;
}
.el-popover.el-popper {
  margin-top: 24px !important;
  margin-left: -11px;
}
.el-select-dropdown.el-popper {
  margin-left: -10px;
  margin-top: 19px !important;
}

.el-tabs__item {
    background: var(--inActiveTab);
    margin-right: 1px;
    border-radius: 4px 4px 0px 0px;
    width: 188.86px !important;
}

/* Custom nave style */
.el-menu {
  width: 100%;
}

.el-menu--horizontal>.el-menu-item {
  height: 38px;
  padding: 0px;
  display: flex;
  border-bottom: none;
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
}

.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: none;
}

.el-tooltip__popper.is-light[x-placement^=bottom] .popper__arrow {
  left: 8px !important;
}
.list__size {
  position: absolute;
  right: 0px;
}
.sortIcon, .bigPopUp {
  display: flex;
}

.menuLable .csvFile:hover {
  opacity:0.6;
}

.menuLable .IconSort:hover {
  opacity:0.6;
}
.select_custom_box .el-checkbox__label {
  padding-left: 4px !important;
  margin-left: 0px !important;
}
</style>
